
export const translations = {
    table: {
        header:[
            {id:1, label:'ID'},
            {id:2, label:'Categoría'},
            {id:3, label:'Orden'},
            {id:4, label:'Descripción'},
            {id:5, label:'Color'},
            {id:6, label:''},
        ],
        nodata:'No existen categorías registradas'
    },
    modal: {
        add_title:'Agregar categoría',
        button:'Agregar',
        form:{
            name:{
                label:'Nombre',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            color:{
                label:'Color',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            description:{
                label:'Descripción',
                helperText:'Este campo debe tener al menos 1 caracter y máximo 255'
            },
            order:{
                label:'Orden',
                helperText:'Seleccione una opción'
            },
            url:{
                label:'Url',
                helperText:'Este campo es obligatorio'
            }
        }
    },
}

